/* Игровые компоненты: неон Кибергорода, тот же язык, что в прототипе */

.counter {
  display: inline-flex;
  align-items: center;
  gap: var(--mnk-space-2);
  min-height: 40px;
  padding: 6px var(--mnk-space-4) 6px var(--mnk-space-3);
  border-radius: var(--mnk-radius-pill);
  background: var(--mnk-surface);
  border: 1px solid var(--mnk-border);
  font-family: var(--mnk-font-mono);
  font-size: var(--mnk-text-lg);
  line-height: 1;
  color: var(--mnk-text);
}

/* Счётчик подсказок работает кнопкой: нажал — взял подсказку */
.counterButton {
  cursor: pointer;
  transition: border-color var(--mnk-duration-fast) var(--mnk-ease), background var(--mnk-duration-fast) var(--mnk-ease);
}

.counterButton:hover:not(:disabled) {
  border-color: var(--mnk-accent);
  background: var(--mnk-surface-hover);
}

.counterButton:active:not(:disabled) {
  transform: translateY(1px);
}

.counterButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Круглая кнопка поверх сцены */
.iconButton {
  display: inline-grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--mnk-border);
  background: var(--mnk-surface);
  color: var(--mnk-text);
  cursor: pointer;
  transition: border-color var(--mnk-duration-fast) var(--mnk-ease);
}

.iconButton:hover {
  border-color: var(--mnk-accent);
}

.counterIcon {
  color: var(--mnk-danger);
  filter: drop-shadow(0 0 6px currentColor);
}

.counterHint {
  color: var(--mnk-amber, var(--mnk-warning));
}

.counterTimer {
  color: var(--mnk-text-faint);
  font-size: var(--mnk-text-sm);
  margin-left: var(--mnk-space-1);
}

.stars {
  display: inline-flex;
  gap: 3px;
  color: var(--mnk-text-faint);
}

.starOn {
  color: var(--mnk-amber, var(--mnk-warning));
  filter: drop-shadow(0 0 6px currentColor);
}

/* ---------- Панель в духе пульта ---------- */

.panel {
  position: relative;
  background: linear-gradient(160deg, rgba(20, 30, 48, 0.94), rgba(8, 12, 22, 0.94));
  border: 1px solid var(--mnk-border);
  border-radius: var(--mnk-radius-lg);
  padding: var(--mnk-space-4);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    var(--mnk-shadow-md);
}

.panel::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  background:
    repeating-linear-gradient(
      0deg,
      rgba(62, 240, 255, 0.04) 0 1px,
      transparent 1px 3px
    );
  opacity: 0.6;
}

/* ---------- Неоновая кнопка ---------- */

.neon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--mnk-space-2);
  font-family: var(--mnk-font-display);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-size: var(--mnk-text-md);
  padding: var(--mnk-space-3) var(--mnk-space-5);
  border-radius: var(--mnk-radius-md);
  border: 1px solid var(--mnk-accent);
  background: rgba(62, 240, 255, 0.08);
  color: var(--mnk-accent);
  cursor: pointer;
  text-shadow: 0 0 10px rgba(62, 240, 255, 0.6);
  box-shadow:
    0 0 14px rgba(62, 240, 255, 0.25),
    inset 0 0 14px rgba(62, 240, 255, 0.12);
  transition: all var(--mnk-duration-fast) var(--mnk-ease);
}

.neon:hover:not(:disabled) {
  background: rgba(62, 240, 255, 0.16);
  box-shadow:
    0 0 24px rgba(62, 240, 255, 0.4),
    inset 0 0 18px rgba(62, 240, 255, 0.2);
}

.neon:active:not(:disabled) {
  transform: translateY(1px);
}

.neon:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.neonMagenta {
  border-color: var(--mnk-magenta, #ff3df0);
  color: var(--mnk-magenta, #ff3df0);
  background: rgba(255, 61, 240, 0.08);
  text-shadow: 0 0 10px rgba(255, 61, 240, 0.6);
  box-shadow:
    0 0 14px rgba(255, 61, 240, 0.25),
    inset 0 0 14px rgba(255, 61, 240, 0.12);
}

/* ---------- Карточки главы и уровня ---------- */

.chapter {
  position: relative;
  border-radius: var(--mnk-radius-lg);
  overflow: hidden;
  border: 1px solid var(--mnk-border);
  background: var(--mnk-surface);
  padding: var(--mnk-space-5);
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: var(--mnk-space-2);
}

.chapterCover {
  position: absolute;
  inset: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  opacity: 0.45;
}

.chapterShade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(5, 7, 11, 0.2), rgba(5, 7, 11, 0.92));
}

.chapterBody {
  position: relative;
}

.chapterTitle {
  font-family: var(--mnk-font-display);
  font-size: var(--mnk-text-xl);
  margin: 0;
  color: var(--mnk-text);
}

.chapterSubtitle {
  color: var(--mnk-text-muted);
  font-size: var(--mnk-text-md);
  margin: var(--mnk-space-2) 0 0;
}

.chapterLocked {
  opacity: 0.75;
}

.level {
  display: flex;
  align-items: center;
  gap: var(--mnk-space-3);
  width: 100%;
  padding: var(--mnk-space-4);
  border-radius: var(--mnk-radius-md);
  border: 1px solid var(--mnk-border);
  background: var(--mnk-surface);
  color: var(--mnk-text);
  cursor: pointer;
  text-align: left;
  transition: all var(--mnk-duration-fast) var(--mnk-ease);
}

.level:hover:not(:disabled) {
  border-color: var(--mnk-accent);
  background: var(--mnk-surface-hover);
}

.level:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.levelIndex {
  width: 42px;
  height: 42px;
  flex: none;
  font-size: var(--mnk-text-lg);
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 1px solid var(--mnk-border-strong);
  font-family: var(--mnk-font-mono);
  color: var(--mnk-text-muted);
}

.levelDone {
  border-color: var(--mnk-success);
  color: var(--mnk-success);
}

.levelBody {
  flex: 1;
  min-width: 0;
}

.levelTitle {
  font-weight: 600;
  font-size: var(--mnk-text-lg);
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.levelMeta {
  font-size: var(--mnk-text-sm);
  color: var(--mnk-text-faint);
}

/* ---------- Верхняя панель игры ---------- */

.hud {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--mnk-space-3);
  padding: var(--mnk-space-3) var(--mnk-space-2);
  flex-wrap: wrap;
}

.hudSide {
  display: flex;
  align-items: center;
  gap: var(--mnk-space-2);
}

.hudTitle {
  font-family: var(--mnk-font-display);
  font-size: var(--mnk-text-lg);
  letter-spacing: 0.04em;
}
